import AjaxLoad from '../../utilities/js/ajax-load';
import { createElementFromHTML, serializeForm, getFormData } from '../../utilities/js/helper';
import { trackingSend } from '../../utilities/js/dl-Tracking';
import { WidgetInstance } from 'friendly-challenge';

class Ajaxform {
    constructor (el, options) {
        const defaults = {
            formAttr: null,
            resultsAttr: 'data-ajaxform-results',
            sortAttr: 'data-ajaxform-sort',
            chooseAttr: 'data-ajaxform-choose',
            chooseValueAttr: 'data-ajaxform-choosevalue',
            referrerAttr: 'data-ajaxform-referrer',
            downloadAttr: 'data-ajaxform-download',
            switchAttr: 'data-ajaxform-switch',
            loading: null,
            offset: 0,
            offsetElement: null,
            onBeforeSubmit: null,
            onSubmitted: null,
            onSuccessRemoved: null,
            buttonDisabledClass: 'button--disabled'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$ajaxform = el;
        this.$form = this.$ajaxform.querySelector('form');
        this.$form_results = this.$ajaxform.querySelector('[' + this.settings.resultsAttr + ']');
        this.$form_sort = this.$ajaxform.querySelector('[' + this.settings.sortAttr + ']');
        this.$form_switch = this.$ajaxform.querySelector('[' + this.settings.switchAttr + ']');
        this.offset = this.settings.offset;
        this.$downloadField = '';
        this.$loading = '';
        this.allowHistory = true;
        this.doNotSubmit = false;
        this.filterForm = this.$form?.getAttribute('id') === 'kitchenoverview-form';
    }

    initialize () {
        if (this.settings.formAttr !== null) {
            this.$form = this.$ajaxform.querySelector('[' + this.settings.formAttr + ']');
        }

        if (this.settings.offsetElement !== null) {
            this.offset = this.settings.offsetElement[0].offsetHeight + this.settings.offset;

            window.on('resize', () => {
                this.offset = this.settings.offsetElement[0].offsetHeight + this.settings.offset;
            });
        }

        if (this.$ajaxform.querySelector('[' + this.settings.downloadAttr + ']')) {
            this.$downloadField = this.$ajaxform.querySelector('[' + this.settings.downloadAttr + ']');
        }

        if (this.$form) {
            const $button = this.$form.querySelector('button[type="submit"]');

            this.initForm(this.$form);
            this.initCaptcha(this.$form, $button);
        }

        if (this.$form_sort) this.initSort(this.$form_sort);

        if (this.$form_switch) {
            this.$form_switch.addEventListener('change', () => {
                this.$form.submit();
            });
        }

        const setNewFilter = () => {
            this.allowHistory = false;

            this.$form.querySelectorAll('input:checked').forEach((item) => {
                item.checked = false;
                item.closest('.filter__item').firstElementChild.classList.remove('is--visible');
            });
            this.setHistoryData(history.state, () => {
                this.submitForm(this.$form);
            });
        };

        if (this.filterForm) {
            if (document.referrer.indexOf('/kuechen/') && document.referrer !== document.location.href) {
                if (history.state !== null) {
                    if (history.state.type === 'ajax') {
                        setNewFilter();
                    }
                }
            }

            window.onpopstate = (e) => {
                if (e.state !== null) {
                    if (e.state.type === 'ajax') {
                        setNewFilter();
                    }
                } else {
                    location.replace(window.location.href);
                }
            };

            this.$form.addEventListener('click', (e) => {
                if (e.target.dataset.filterFormReset === '') {
                    e.preventDefault();
                    this.$form.reset();

                    // Check if Form got a RangeSlider and Reset to Default Values
                    const $rangeSliderFrom = this.$form.querySelector('[data-filter-rangefrom]');
                    const $rangeSliderTo = this.$form.querySelector('[data-filter-rangeto]');
                    if ($rangeSliderFrom) {
                        $rangeSliderFrom.value = $rangeSliderFrom.getAttribute('data-filter-rangefrom');
                        $rangeSliderTo.value = $rangeSliderTo.getAttribute('data-filter-rangeto');
                    }

                    const checkboxes = this.$form.querySelectorAll('input[type="checkbox"]');

                    checkboxes.forEach(cb => {
                        cb.checked = false;
                    });

                    this.submitForm(this.$form);
                }
            });
        }

        if (this.$form) {
            const $$mailSends = this.$form.querySelectorAll('[data-mailsend]');
            if ($$mailSends.length > 0) {
                import('../../services/mail-send').then(({ MailSend }) => {
                    $$mailSends.forEach(($mailsend) => {
                        const mailSend = new MailSend($mailsend);
                        mailSend.initialize();
                    });
                });
            }
        }
    }

    setHistory (formAction) {
        history.pushState(getFormData(this.$form, 'object'), '', formAction);
    }

    setHistoryData (data, callback) {
        for (const key in data) {
            const $domElement = this.$form.querySelector('[name="' + key + '"]');

            if ($domElement) {
                if ($domElement.nodeName === 'INPUT') {
                    if ($domElement.type === 'checkbox' || $domElement.type === 'radio') {
                        let valueArr = [];

                        if (data[key].includes(',')) {
                            valueArr = data[key].split(',');
                        } else {
                            valueArr.push(data[key]);
                        }

                        valueArr.forEach((value) => {
                            const $target = this.$form.querySelector('[name="' + key + '"][value="' + value + '"]');

                            if ($target) {
                                $target.checked = true;
                            }
                            $target.closest('.filter__item').firstElementChild.classList.add('is--visible');
                        });
                    } else {
                        $domElement.value = data[key];
                    }
                }

                if ($domElement.nodeName === 'SELECT') {
                    this.doNotSubmit = true;
                    $domElement.slim.setSelected(data[key]);
                    this.doNotSubmit = false;
                }
            }
        }

        if (typeof callback === 'function') {
            callback();
        }
    }

    initSort ($sort) {
        $sort.addEventListener('change', () => {
            if (!this.doNotSubmit) {
                $sort.closest('form').dispatchEvent(new Event('submit', {
                    bubbles: true,
                    cancelable: false
                }));
            }
        });
    }

    submitForm ($currentForm, chooseValue) {
        let formAction = $currentForm.getAttribute('action');
        const formMethod = $currentForm.getAttribute('method');

        if (formMethod.toLowerCase() === 'get') {
            formAction += `?${serializeForm($currentForm)}`;
        }

        const formData = new FormData($currentForm);

        if (this.settings.loading !== null) {
            this.$loading = createElementFromHTML(this.settings.loading);
            $currentForm.appendChild(this.$loading);
        }

        if (typeof this.settings.onBeforeSubmit === 'function') {
            this.settings.onBeforeSubmit();
        }

        const currentFormName = $currentForm.dataset.formName;

        // eslint-disable-next-line no-new
        new AjaxLoad(formAction, {
            requestMethod: formMethod,
            requestData: formData,
            onSuccess: (result) => {
                const $result = createElementFromHTML(result);
                const $loading = $currentForm.querySelector('.loading');
                $loading.parentNode.removeChild($loading);
                const $successInput = $result.querySelector('input[name="form_success"]');

                if ($successInput) {
                    const $success = ($successInput.value !== '') ? JSON.parse($successInput.value) : '';
                    const customPage = window.dataLayer[0]?.page?.customPage ?? window.location.pathname;

                    if (currentFormName) {
                        trackingSend({
                            event: 'form_success',
                            formName: currentFormName,
                            context: customPage
                        });
                    }

                    if (typeof window.dataLayer !== 'undefined') {
                        if ($success && $success !== '') {
                            // eslint-disable-next-line no-undef
                            window.dataLayer.push({
                                event: $success.event,
                                eventData: {
                                    category: $success.eventData.category,
                                    action: $success.eventData.action,
                                    label: $success.eventData.label
                                }
                            });
                        }
                    }
                }

                // check for custom response, when the form is used to duplicate a
                // kitchen from the kitchen online planner tool
                if (result.opSuccess === true) {
                    location.reload();
                }

                const $resultSort = $result.querySelector('[' + this.settings.sortAttr + ']');

                if ($resultSort) {
                    this.initSort($resultSort);
                }

                if (this.$form_results) {
                    this.$form_results.innerHTML = '';
                    const $childs = $result.children;

                    Array.from($childs).forEach(child => {
                        this.$form_results.appendChild(child);
                    });

                    if (typeof this.settings.onSubmitted === 'function') {
                        this.settings.onSubmitted(this.$form_results);
                    }
                } else {
                    this.$ajaxform.innerHTML = '';
                    const $childs = $result.children;

                    Array.from($childs).forEach(element => {
                        this.$ajaxform.appendChild(element);
                    });

                    // this.$ajaxform.append($result.children);

                    if (!this.$ajaxform.querySelector('.form__element--error')) {
                        if (chooseValue === 'download' && typeof this.$downloadField !== 'undefined' && this.$downloadField.value !== '') {
                            window.location.href = this.$downloadField.value;
                        }
                    }

                    if (typeof this.settings.onSubmitted === 'function') {
                        this.settings.onSubmitted(this.$ajaxform.parentNode);
                    }
                }

                if (this.$ajaxform.closest('[data-sidebar-scroller]')) {
                    this.$ajaxform.closest('[data-sidebar-scroller]').scrollTo({
                        top: 100,
                        left: 100,
                        behavior: 'smooth'
                    });
                }

                if (this.allowHistory && this.filterForm) {
                    this.setHistory(formAction);
                }

                this.allowHistory = true;
            }
        });
    }

    initForm ($currentForm) {
        $currentForm.addEventListener('submit', (e, chooseValue) => {
            if ($currentForm.querySelector('[' + this.settings.referrerAttr + ']')) {
                $currentForm.querySelector('[' + this.settings.referrerAttr + ']').value = window.location;
            }
            this.submitForm(this.$form, chooseValue);

            e.preventDefault();
        });

        const $submitBtns = $currentForm.querySelectorAll('[type="submit"]');

        $submitBtns.forEach($submitBtn => {
            $submitBtn.addEventListener('click', (e) => {
                let chooseValue;

                if (typeof $submitBtn.getAttribute(this.settings.chooseAttr) !== 'undefined' && $submitBtn.getAttribute(this.settings.chooseAttr) !== '' && typeof $submitBtn.getAttribute(this.settings.chooseValueAttr) !== 'undefined' && $submitBtn.getAttribute(this.settings.chooseValueAttr) !== '') {
                    const chooseId = $submitBtn.getAttribute(this.settings.chooseAttr);
                    const $chooseSelect = document.getElementById(chooseId?.split('#')[1]);

                    if ($chooseSelect) {
                        chooseValue = $submitBtn.getAttribute(this.settings.chooseValueAttr);
                        $chooseSelect.value = chooseValue;
                    }
                }

                $currentForm.dispatchEvent(new Event('submit', {
                    bubbles: true,
                    cancelable: true
                }));

                e.preventDefault();
            });
        });
    }

    initCaptcha ($form, $button) {
        const $friendlyCaptcha = $form.querySelector('.frc-captcha');

        if ($friendlyCaptcha) {
            $button.classList.add(this.settings.buttonDisabledClass);

            const widget = new WidgetInstance($friendlyCaptcha, {  // eslint-disable-line
                skipStyleInjection: true,
                doneCallback: () => {
                    this.captchaIsReady = true;

                    this.checkValidationAndCaptcha($button);
                }
            });

            $form.addEventListener('change', () => {
                this.checkValidationAndCaptcha($button);
            });

            $form.dispatchEvent(new Event('change', {
                bubbles: true,
                cancelable: true
            }));
        }
    }

    checkValidationAndCaptcha ($button) {
        if (this.captchaIsReady) {
            $button.classList.remove(this.settings.buttonDisabledClass);
        } else {
            $button.classList.add(this.settings.buttonDisabledClass);
        }
    }
}

export { Ajaxform };
